import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "person-circle-64", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 51 51", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: 2.5 },
        React.createElement("g", { fillRule: "evenodd", transform: "translate(5 5)" },
            React.createElement("circle", { cx: 20.813, cy: 16.313, r: 6.188 }),
            React.createElement("path", { strokeLinecap: "round", d: "M9.855 29.623c1.452-4.127 5.809-7.123 10.957-7.123 4.457 0 8.32 2.245 10.22 5.525.296.51.544 1.047.74 1.604" })),
        React.createElement("circle", { cx: 26, cy: 26, r: 19 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
